/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to create a new note
 * @export
 * @interface CreateNoteRequest
 */
export interface CreateNoteRequest {
    /**
     * ID of the claim this note is attached to
     * @type {number}
     * @memberof CreateNoteRequest
     */
    claimId: number;
    /**
     * Plaintext note content
     * @type {string}
     * @memberof CreateNoteRequest
     */
    text: string;
}

/**
 * Check if a given object implements the CreateNoteRequest interface.
 */
export function instanceOfCreateNoteRequest(value: object): value is CreateNoteRequest {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function CreateNoteRequestFromJSON(json: any): CreateNoteRequest {
    return CreateNoteRequestFromJSONTyped(json, false);
}

export function CreateNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'text': json['text'],
    };
}

export function CreateNoteRequestToJSON(json: any): CreateNoteRequest {
    return CreateNoteRequestToJSONTyped(json, false);
}

export function CreateNoteRequestToJSONTyped(value?: CreateNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'text': value['text'],
    };
}

